import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'app-table-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})

export class PaginationComponent  {
  constructor() {}

  @Input() NumPages!: number;
  @Input() CurrentPage!: number;
  @Input() Pagination: any;
  @Input() HasData = false;
  @Input() Loading: boolean | undefined = false;
  @Output() Paginate = new EventEmitter();

  setRows(event: any) {
    const { target } = event;
    const rows = parseInt(target.value);
    this.Pagination.ShowAll = isNaN(rows);
    if (!this.Pagination.ShowAll) {
      const ratio =
        this.Pagination.Page * (this.Pagination.ItemsPerPage / rows);
      if (ratio > 1)
        this.Pagination.Page = Math.floor(
          (this.Pagination.Page * this.Pagination.ItemsPerPage) / rows
        );
      else
        this.Pagination.Page = Math.ceil(
          (this.Pagination.Page * this.Pagination.ItemsPerPage) / rows
        );
      this.Pagination.ItemsPerPage = rows;
      if ((this.Pagination.Page + 1) * rows > this.Pagination.NumItems)
        this.Pagination.Page = Math.floor(this.Pagination.NumItems / rows);
    }
    this.Paginate.emit();
  }

  increasePagination() {
    this.Pagination.Page++;
    this.Paginate.emit();
  }

  decreasePagination() {
    this.Pagination.Page--;
    this.Paginate.emit();
  }  
}
